import { Play } from "lucide-react";

// Nav Cleanup, Stage 2B (2026-11): thumbnail-first inline player for feedback_request posts.
// A SEPARATE small component from GalleryLightbox.jsx/GalleryCard.jsx — Gallery is explicitly
// out of scope and untouched by this feature. Same youtube-nocookie embed pattern, but
// rendered INLINE in the card (never a lightbox overlay) at a fixed 16:9 so the card's height
// never jumps when playback starts. "Only one video plays at a time across the feed" is
// enforced by the PARENT (CommunityTab, which owns the one `playingVideoPostId`) — this
// component holds no state of its own, it only ever renders what `isPlaying` tells it to.
export function FeedbackVideoPlayer({ videoId, isPlaying, onPlay, testId }) {
  if (!videoId) return null;
  return (
    <div
      className="mt-3.5 relative w-full overflow-hidden rounded-lg bg-black/10"
      style={{ aspectRatio: "16 / 9" }}
      data-testid={testId}
    >
      {isPlaying ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
          title="Feedback request video"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 h-full w-full"
          data-testid={`${testId}-iframe`}
        />
      ) : (
        <button onClick={onPlay} data-testid={`${testId}-play-btn`} className="absolute inset-0 w-full h-full group" aria-label="Play video">
          <img src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`} alt="" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
          <span className="absolute inset-0 flex items-center justify-center bg-black/10 group-hover:bg-black/20 transition-colors">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-black/55 group-hover:bg-black/70 transition-colors">
              <Play className="h-6 w-6 text-white fill-white ml-0.5" />
            </span>
          </span>
        </button>
      )}
    </div>
  );
}
